import Users from './UsersContainer';

export default Users;
